module.exports = __webpack_public_path__ + "images/fa-courses-banner.jpg";